export default {
  all: 'Tous',
  app_disabled: 'Nous mettons à jour le contenu, ils seront prochainement disponible',
  autocomplete_placeholder: "Entrez l'adresse ou le code postal",
  back_to_list: 'Retour à la liste',
  catalogue_image: ' Couverture du catalogue',
  catalogue_loading: ' Nous récupérons votre catalogue',
  catalogues: 'Catalogues',
  catalogues_in_area: 'Catalogues dans la région',
  catalogues_loading: ' Chargement',
  catalogues_near_you: 'Catalogues à proximité',
  catalogues_not_found:
    "Il n'y a pas de catalogues à proximité pour le moment, essayez de saisir une autre adresse ou revenez prochainement pour plus d'offres",
  close_catalogues: 'Fermer',
  close_products: 'Fermer',
  close_stores: 'Fermer',
  closed: 'Fermé',
  characteristics: 'Caractéristiques',
  days_of_week: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  description_missing: 'Aucune description disponible',
  expires: 'Expire',
  expired: 'Expiré',
  find_me: 'Trouvez-moi',
  geolocation_error: ' Avertissement : la localisation a échoué',
  geolocation_image: 'Géolocalisation',
  geolocation_info:
    'Pour vous présenter les catalogues des magasins les plus proches de chez vous, nous avons besoin de connaître votre emplacement. Entrez votre adresse ou votre code postal.',
  geolocation_loading: 'Nous définissons votre position',
  geolocation_missing:
    ' Mettez à jour votre position pour obtenir les offres et les magasins les plus proches de chez vous.',
  localize_yourself: ' Localisez-vous',
  more_info: "Plus d'informations",
  next: 'Suivant',
  not_now: 'Pas maintenant',
  of: 'De',
  open: 'Ouvrir',
  open_24_hours: 'Ouvert 24 heures sur 24',
  or: 'ou',
  other_stores: 'Offres également disponibles ici :',
  page: 'Page',
  previous: 'Précédent',
  price: 'Prix',
  products: 'Produits',
  products_find: 'Rechercher un produit',
  index: 'Index',
  products_list: 'Liste de produits',
  read_all: 'Lire tout',
  sale: 'Remise',
  search_placeholder: 'Que cherchez-vous ?',
  stores: 'Magasins',
  understand: 'je comprends',
  usergeolocation_label:
    'Entrez votre adresse pour trouver les meilleures offres dans les magasins à proximité',
  fullscreen: 'Plein écran',
  fullscreenExit: "Réduire l'écran",
  no_nearest_store_at: 'Pas de magasin à proximité',
  nearest_store_at: 'Magasin le plus proche à {distance}',
  nearby_stores: 'Magasins à proximité',
  show_all_pages: 'Voir toutes les pages',
  show: 'montrer',
  directionVertical: 'Défilement vertical',
  directionHorizontal: 'Défilement horizontal',
  share: 'partage',
  share_with_friends: 'Partager avec vos amis',
  copy_link: 'Copier le lien',
  sms: 'SMS',
  email: 'email',
  more_stores: 'autres magasins',
  stores_within: 'Magasins dans un rayon de {maxDistance}',
  invalid_offers_disclaimer:
    'Les offres de ce catalogue ne sont pas valables dans les magasins près de chez vous, ouvrez un autre catalogue ou localisez-les dans une autre zone.',
  download_pdf: 'Télécharger le PDF',
  available_options: 'Disponible en {numOptions} options:',
  flyer_unavailable_error:
    "Impossible d'ouvrir ce catalogue. Vérifiez le lien ou réessayez plus tard.",
};
